<template>
  <div
    class="card-direction"
    :class="{
      [`size-${size}`]: !!size,
    }"
    :style="{
      '--card-color': getCardColor(slug),
    }"
  >
    <div class="figure" />

    <img
      :src="
        DIRECTION_ILLUSTRATIONS?.[slug as string] ||
        DIRECTION_ILLUSTRATIONS.football
      "
      class="image"
    />
  </div>
</template>

<script lang="ts" setup>
import { DIRECTION_ILLUSTRATIONS, SLUG_CARD_COLORS, type Slug } from '~/shared'

defineOptions({
  name: 'CardDirection',
})

defineProps<{
  slug: Slug
  size?: 'small'
}>()

const getCardColor = (slug: Slug): string =>
  SLUG_CARD_COLORS?.[slug as keyof typeof SLUG_CARD_COLORS] ||
  SLUG_CARD_COLORS.default
</script>

<style lang="scss" scoped>
.card-direction {
  position: relative;
  width: 90px;
  height: 90px;
  flex-shrink: 0;
  flex-grow: 0;

  &.size-small {
    width: 60px;
    height: 60px;

    .image {
      width: 42.5px;
    }
  }

  @include max-md {
    width: 60px;
    height: 60px;
  }
}

.figure {
  position: absolute;
  width: calc(70.71% + 12px * 0.4142);
  height: calc(70.71% + 12px * 0.4142);
  border-radius: 12px;
  background: var(--card-color);

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  z-index: 0;
}

.image {
  position: absolute;
  top: 10px;
  right: 0;
  width: 74px;
  z-index: 2;

  @include max-md {
    width: 50px;
  }
}
</style>
